// SPDX-FileCopyrightText: Copyright (C) 2026 provide.io llc
// SPDX-License-Identifier: Apache-2.0
import type { RouteObject } from "react-router";
import { loadRouteComponent } from "./lib/lazy-route";
import { Root } from "./root";
import { AuthCallback } from "./routes/auth.callback";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/_index"),
            (m) => m.Home,
          ),
      },
      {
        path: "d/:name",
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/d.$name"),
            (m) => m.DomainPage,
          ),
      },
      {
        path: "wildcard",
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/wildcard"),
            (m) => m.WildcardPage,
          ),
      },
      {
        path: "pricing",
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/pricing"),
            (m) => m.PricingPage,
          ),
      },
      {
        path: "pricing/:tld",
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/pricing.$tld"),
            (m) => m.PricingDetailPage,
          ),
      },
      {
        path: "wildcard/:name",
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/wildcard.$name"),
            (m) => m.WildcardResultPage,
          ),
      },
      {
        path: "playground",
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/playground"),
            (m) => m.PlaygroundPage,
          ),
      },
      { path: "auth/callback", element: <AuthCallback /> },
      {
        path: "admin",
        lazy: () =>
          loadRouteComponent(
            () => import("./routes/admin/_layout"),
            (m) => m.AdminLayout,
          ),
        children: [
          {
            index: true,
            lazy: () =>
              loadRouteComponent(
                () => import("./routes/admin/_index"),
                (m) => m.AdminIndex,
              ),
          },
          {
            path: "cache",
            lazy: () =>
              loadRouteComponent(
                () => import("./routes/admin/cache"),
                (m) => m.AdminCachePage,
              ),
          },
          {
            path: "tlds",
            lazy: () =>
              loadRouteComponent(
                () => import("./routes/admin/tlds"),
                (m) => m.AdminTldsPage,
              ),
          },
        ],
      },
    ],
  },
];
